import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as Add } from '../../../assets/icons/plus.svg'
import { useUsersStore } from '../../../stores/usersStore'
import { IRoleEnum } from '../../../types/router'
import { emailRegex } from '../../../utils/regexes'
import RoleSelect from '../RoleSelect/RoleSelect'

import styles from './add-user.module.scss'

function AddUser() {
    const { t } = useTranslation()

    const [, { addUser }] = useUsersStore()

    const [name, setName] = useState('')
    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [role, setRole] = useState<IRoleEnum>(1)

    const handleAddUser = (e?: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault()

        const isDataValid = !email || !password || !emailRegex.test(email)

        if (isDataValid) return

        addUser(name, email, password, role)
    }

    return (
        <div className={styles.addUser}>
            <form className={styles.addUser__form} onSubmit={handleAddUser}>
                <input
                    className={styles.addUser__input}
                    placeholder={t('name')}
                    name="name"
                    type="text"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <input
                    className={styles.addUser__input}
                    placeholder={t('email')}
                    name="email"
                    type="text"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <input
                    className={styles.addUser__input}
                    placeholder={t('password')}
                    name="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <RoleSelect role={role} setRole={setRole} />
                <button className={styles.addUser__btn} type="submit">
                    <Add className={styles.addUser__icon} />
                </button>
            </form>
        </div>
    )
}

export default AddUser
